/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{clamp as t}from"../../../utils/clamp.js";const r={test:t=>"number"==typeof t,parse:parseFloat,transform:t=>t},o={...r,transform:r=>t(0,1,r)},s={...r,default:1};export{o as alpha,r as number,s as scale};
//# sourceMappingURL=index.js.map
